export default {
  isDev () {
    return process.env.NODE_ENV === 'development' ? true : false
  },
  isProd () {
    return process.env.NODE_ENV === 'production' ? true : false
  },
  isMobile () {
    return window.matchMedia('(max-width: 768px)').matches
  },
  isTablet () {
    return window.matchMedia('(min-width: 769px) and (max-width: 1024px)').matches
  },
  isDesktop () {
    return window.matchMedia('(min-width: 1024px)').matches
  },
  getParamValue (param) {
    const url_string = window.location.href
    const url = new URL(url_string);

    return url.searchParams.get(param)
  },
  isHexValid (hex) {
    return /^[0-9A-F]{6}$/i.test(hex)
  },
  currentFormat (locale) {
    return locale === 'en' ? 'Y-m-d' : 'd/m/Y'
  },
  currentDay (locale) {
    let date = new Date()
    let dd = date.getDate()
    let mm = date.getMonth() + 1 // Because getMonth start at 0 ....
    let yyyy = date.getFullYear()

    if(dd < 10) dd = `0${dd}`
    if(mm < 10) mm = `0${mm}`

    return locale === 'en' ? `${yyyy}-${mm}-${dd}` : `${dd}/${mm}/${yyyy}`
  },
  generateNameSelector (id) {
    return `[name="options[${id}]"]`
  },
  generateNameAndValueSelector (id, value) {
    return `[name="options[${id}]"][value="${value}"]`
  },
  generateDataSelector(id, value) {
    return `[data-selector="options[${id}][${value}]"]`;
   },
   getInputBySpanText(spanText) {
    const labels = document.querySelectorAll('.field.choice label span');
        for (const label of labels) {
        if (label.textContent.trim() === spanText) {
        const fieldChoice = label.closest('.field.choice');
            if (fieldChoice) {
                return fieldChoice.querySelector('input.product-custom-option');
            }
        }
    }
   },

    pushDataLayer (pushObject) {
    window.dataLayer = window.dataLayer || [] ;
    window.dataLayer.push(pushObject)
  },
  isChecked (node) {
    return node.className.includes('selected')
  }
}
